<div class="leaflet-map-container" [class.drawing-mode]="drawingMode">
  <div #mapContainer class="map-element" [style.height]="height" [class.drawing-mode]="drawingMode">
    <div class="map-loading" *ngIf="!isMapInitialized">
      <div class="loading-spinner"></div>
      <p>Loading map...</p>
    </div>
  </div>
</div>